









































import { Component, Vue } from 'vue-property-decorator';
import { stAccountApi } from '@/services/st-api';
import { notifySuccess } from '@/utlitities/notifications';
import { DeleteAccountEditModel } from '@/services/api/nswag/stapiclient_generated';
import StSettingsSeparator from '@/components/basic/Form/StSettingsSeparator.vue';

@Component({
  components: {StSettingsSeparator},
})
export default class AccountSettingsPrivacy extends Vue {
  loading: boolean = false;
  editModel: DeleteAccountEditModel = DeleteAccountEditModel.fromJS({});

  async deleteAccount() {
    try {
      this.loading = true;
      await stAccountApi.deleteAccount(this.editModel);
      notifySuccess('Der Account wurde gelöscht');
      alert('Der Account wurde gelöscht!');
      window.location.href = "https://www.spiketime.de";
    } finally {
      this.loading = false;
    }
  }
}
